import React from 'react';
import './EntityPropertiesDefs.css';

const EntityPropertiesDefs = () => {
  return (
    <div style={{ display: 'none' }}>
      <svg id="EntityPropertiesDesfs">
        <defs>
          <symbol id="fp_file_hash" data-name="fp_file hash" viewBox="0 0 15.5 16.25">
            <g id="_029_sha256-1-3" data-name="029_sha256-1">
              <line className="entity-properties-13" x1="7.28" y1="0.75" x2="3.84" y2="15.42" />
              <line className="entity-properties-13" x1="11.66" y1="0.83" x2="8.22" y2="15.5" />
              <line className="entity-properties-13" x1="0.75" y1="10.51" x2="13.58" y2="10.75" />
              <line className="entity-properties-13" x1="1.92" y1="5.5" x2="14.75" y2="5.75" />
            </g>
          </symbol>
          <symbol id="fp_Size-2" data-name="fp_Size-2" viewBox="0 0 21.8 23.75">
            <circle className="entity-properties-10" cx="10.9" cy="14.95" r="0.76" />
            <line className="entity-properties-10" x1="10.9" y1="14.19" x2="10.9" y2="10.95" />
            <circle className="entity-properties-10" cx="10.9" cy="14.95" r="5.32" />
            <path
              className="entity-properties-10"
              d="M10.63,7.48A7.66,7.66,0,0,0,3.36,15.2v7a1.16,1.16,0,0,0,1.16,1.16H17.28a1.16,1.16,0,0,0,1.16-1.16V15A7.54,7.54,0,0,0,10.63,7.48Z"
            />
            <line className="entity-properties-10" x1="12.4" y1="7.62" x2="12.4" y2="5.43" />
            <line className="entity-properties-10" x1="9.4" y1="5.43" x2="9.4" y2="7.63" />
            <path
              className="entity-properties-10"
              d="M.38.37H21.43a0,0,0,0,1,0,0v.92a2.09,2.09,0,0,1-2.09,2.09H2.47A2.09,2.09,0,0,1,.38,1.29V.37a0,0,0,0,1,0,0Z"
            />
          </symbol>
          <symbol id="fp_Full_Path-2" data-name="fp_Full Path-2" viewBox="0 0 24.75 21.51">
            <polyline className="entity-properties-10" points="14.89 13.25 0.38 13.25 0.38 0.38 24.38 0.38" />
            <line className="entity-properties-10" x1="24.38" y1="13.25" x2="17.47" y2="13.25" />
            <line className="entity-properties-10" x1="23.79" y1="3.61" x2="23.79" y2="10.02" />
            <path
              className="entity-properties-10"
              d="M21.22,19.63l-1.7-2.24,1.52-.3a.29.29,0,0,0,.14-.49L15,11.06a.29.29,0,0,0-.47.26L16,19.39a.29.29,0,0,0,.49.15l1.22-1.22L19.18,21a.29.29,0,0,0,.41.1L21.16,20A.29.29,0,0,0,21.22,19.63Z"
            />
            <polyline className="entity-properties-10" points="3.08 5.37 4.29 8.61 5.48 5.37 6.69 8.61 7.88 5.37" />
            <polyline className="entity-properties-10" points="9.39 5.37 10.6 8.61 11.79 5.37 13.01 8.61 14.2 5.37" />
            <polyline
              className="entity-properties-10"
              points="15.61 5.37 16.82 8.61 18.01 5.37 19.22 8.61 20.41 5.37"
            />
            <line className="entity-properties-10" x1="21.49" y1="8.61" x2="21.49" y2="8.61" />
          </symbol>
          <symbol id="fp_Endpoints-2" data-name="fp_Endpoints-2" viewBox="0 0 24.75 19.19">
            <rect className="entity-properties-10" x="0.37" y="14.64" width="5.22" height="4.17" />
            <rect className="entity-properties-10" x="9.77" y="14.64" width="5.22" height="4.17" />
            <rect className="entity-properties-10" x="9.77" y="0.37" width="5.22" height="4.17" />
            <rect className="entity-properties-10" x="19.16" y="14.64" width="5.22" height="4.17" />
            <path className="entity-properties-10" d="M12.42,11.63" />
            <polyline className="entity-properties-10" points="3.5 12.03 3.5 9.42 12.42 9.42 21.25 9.42 21.25 12.03" />
            <line className="entity-properties-10" x1="12.42" y1="12.03" x2="12.42" y2="5.85" />
          </symbol>
          <symbol id="fp_Endpoints-2-blue" data-name="fp_Endpoints-2" viewBox="0 0 24.75 19.19">
            <rect
              className="entity-properties-10 entity-properties-10-blue"
              x="0.37"
              y="14.64"
              width="5.22"
              height="4.17"
            />
            <rect
              className="entity-properties-10 entity-properties-10-blue"
              x="9.77"
              y="14.64"
              width="5.22"
              height="4.17"
            />
            <rect
              className="entity-properties-10 entity-properties-10-blue"
              x="9.77"
              y="0.37"
              width="5.22"
              height="4.17"
            />
            <rect
              className="entity-properties-10 entity-properties-10-blue"
              x="19.16"
              y="14.64"
              width="5.22"
              height="4.17"
            />
            <path className="entity-properties-10 entity-properties-10-blue" d="M12.42,11.63" />
            <polyline
              className="entity-properties-10 entity-properties-10-blue"
              points="3.5 12.03 3.5 9.42 12.42 9.42 21.25 9.42 21.25 12.03"
            />
            <line
              className="entity-properties-10 entity-properties-10-blue"
              x1="12.42"
              y1="12.03"
              x2="12.42"
              y2="5.85"
            />
          </symbol>
          <symbol id="fp_Product-2" data-name="fp_Product-2" viewBox="0 0 21.75 21.75">
            <circle className="entity-properties-10" cx="10.88" cy="10.88" r="10.5" />
            <circle className="entity-properties-9" cx="10.88" cy="10.88" r="5.65" />
          </symbol>
          <symbol id="fp_Copyright-2" data-name="fp_Copyright-2" viewBox="0 0 21.75 21.75">
            <path
              className="entity-properties-9"
              d="M3.57,10.88A7.29,7.29,0,0,0,7.23,17.2a7.29,7.29,0,0,0,7.3,0,7.33,7.33,0,0,0,3.65-6.32,7.29,7.29,0,0,0-3.66-6.33,7.29,7.29,0,0,0-7.3,0,7.33,7.33,0,0,0-3.65,6.32Zm7.82-3.34a2.08,2.08,0,0,0-1.8.89A4.15,4.15,0,0,0,9,10.88q0,3.35,2.43,3.35A6.67,6.67,0,0,0,12.86,14a6.33,6.33,0,0,0,1.47-.53v2.29a7,7,0,0,1-3,.68A4.82,4.82,0,0,1,7.53,15a6,6,0,0,1-1.34-4.14,5.91,5.91,0,0,1,1.32-4.1,4.74,4.74,0,0,1,3.71-1.47,8.13,8.13,0,0,1,3.65.93l-.89,2A5.69,5.69,0,0,0,11.39,7.53Z"
            />
            <circle className="entity-properties-10" cx="10.88" cy="10.88" r="10.5" />
          </symbol>
          <symbol id="fp_file_properties" data-name="fp_file properties" viewBox="0 0 24 20.46">
            <path
              className="entity-properties-14"
              d="M5.82,13.35C7.94,8.81,8.49.5,8.49.5l15,.44c-.07.77-2.5,29.76-9.74,14.68L.5,15.31s.95,4.42,4.33,4.5c4.38.1,12.89.14,12.89.14"
            />
            <line className="entity-properties-14" x1="11.57" y1="4.97" x2="19.22" y2="5.24" />
            <line className="entity-properties-14" x1="11.01" y1="8.43" x2="18.16" y2="8.68" />
            <line className="entity-properties-14" x1="10.1" y1="11.9" x2="14.18" y2="12.05" />
          </symbol>
          <symbol id="fp_ile_certificate" data-name="fp_ile certificate" viewBox="0 0 12.96 23">
            <polyline className="entity-properties-14" points="10 13.96 10 22.5 6.53 19.04 3.06 22.5 3.06 13.96" />
            <path
              className="entity-properties-14"
              d="M12.2,9a2.08,2.08,0,0,0-.55-2.4,2.06,2.06,0,0,0-1.43-3.69A2.06,2.06,0,0,0,6.6,1.31,2.06,2.06,0,0,0,2.91,2.74a2.06,2.06,0,0,0-1.6,3.62,2.06,2.06,0,0,0,1.43,3.69,2.06,2.06,0,0,0,3.62,1.6,2.06,2.06,0,0,0,3.69-1.43A2.08,2.08,0,0,0,12.2,9ZM5.66,8.32a2,2,0,1,1,2.66-1A2,2,0,0,1,5.66,8.32Z"
            />
          </symbol>
          <symbol id="fp_file_overview" data-name="fp_file overview" viewBox="0 0 23 15.94">
            <ellipse className="entity-properties-14" cx="11.5" cy="7.97" rx="4.38" ry="4.52" />
            <ellipse className="entity-properties-14" cx="11.5" cy="7.97" rx="1.8" ry="1.86" />
            <path
              className="entity-properties-14"
              d="M22.5,8C20.29,3.5,16.19.5,11.5.5S2.71,3.5.5,8c2.21,4.47,6.31,7.47,11,7.47S20.29,12.44,22.5,8Z"
            />
          </symbol>
          <symbol id="running_files-2" data-name="running files-2" viewBox="0 0 20.88 23.75">
            <circle
              className="entity-properties-18"
              cx="17.56"
              cy="3.2"
              r="1.81"
              transform="translate(9.27 19.01) rotate(-72.64)"
            />
            <path
              className="entity-properties-18"
              d="M15.95,23.75s0-4.19-.09-5.52a1,1,0,0,0-.28-.64l-3-3.15A1.85,1.85,0,0,1,12.44,13L13.7,9A2,2,0,0,1,16,7.53,2.07,2.07,0,0,1,17.49,10L17,14l3.88.06"
            />
            <polyline className="entity-properties-18" points="11.53 15.75 9.78 18.09 5.21 18.09" />
            <polyline className="entity-properties-18" points="12.79 7.08 10.88 7.08 8.96 11.13" />
            <line className="entity-properties-18" x1="6.2" y1="11.13" x2="2.85" y2="11.13" />
            <line className="entity-properties-18" x1="10.52" y1="13.95" x2="2.85" y2="13.95" />
            <g id="_Group_15" data-name="&lt;Group&gt;">
              <g id="_Group_16" data-name="&lt;Group&gt;">
                <polyline
                  className="entity-properties-18"
                  points="3.99 18.25 0.5 18.25 0.5 4.87 4.87 0.5 12.88 0.5 12.88 3.82"
                />
                <polyline
                  id="_Path_38"
                  data-name="&lt;Path&gt;"
                  className="entity-properties-18"
                  points="0.5 4.87 4.87 4.87 4.87 0.5"
                />
              </g>
            </g>
          </symbol>
          <symbol id="running_files-1" data-name="running files-1" viewBox="0 0 20.88 23.75">
            <circle
              className="entity-properties-19"
              cx="17.56"
              cy="3.2"
              r="1.81"
              transform="translate(9.27 19.01) rotate(-72.64)"
            />
            <path
              className="entity-properties-19"
              d="M15.95,23.75s0-4.19-.09-5.52a1,1,0,0,0-.28-.64l-3-3.15A1.85,1.85,0,0,1,12.44,13L13.7,9A2,2,0,0,1,16,7.53,2.07,2.07,0,0,1,17.49,10L17,14l3.88.06"
            />
            <polyline className="entity-properties-19" points="11.53 15.75 9.78 18.09 5.21 18.09" />
            <polyline className="entity-properties-19" points="12.79 7.08 10.88 7.08 8.96 11.13" />
            <line className="entity-properties-19" x1="6.2" y1="11.13" x2="2.85" y2="11.13" />
            <line className="entity-properties-19" x1="10.52" y1="13.95" x2="2.85" y2="13.95" />
            <g id="_Group_13" data-name="&lt;Group&gt;">
              <g id="_Group_14" data-name="&lt;Group&gt;">
                <polyline
                  className="entity-properties-19"
                  points="3.99 18.25 0.5 18.25 0.5 4.87 4.87 0.5 12.88 0.5 12.88 3.82"
                />
                <polyline
                  id="_Path_37"
                  data-name="&lt;Path&gt;"
                  className="entity-properties-19"
                  points="0.5 4.87 4.87 4.87 4.87 0.5"
                />
              </g>
            </g>
          </symbol>
        </defs>
      </svg>
    </div>
  );
};

export default EntityPropertiesDefs;
